/** @format */

import Router from './routes/routes';



const App = () => {
  return(
    <Router />
  );
}

export default App;